module.exports = __webpack_public_path__ + "img/logo1.bf906295.svg";